import React, {Component} from 'react'
import TagSuggestions from './TagSuggestions'
import Tag from '../../NewWorkInstruction/Tag'

class EditTagsForm extends Component {
        state = {
            recentlyCreatedTagName: "",
            newTagName: '',
            newTagNames: [],
            selectedTagIds: [],
            allTags: this.props.currentWorkInstructionTags,
            searchInput: "",
            pendingRemovals: []
    }

    assignTags = async () => {
        const {selectedTagIds, pendingRemovals, newTagNames} = this.state
        const { workInstructionId, EditTagsAdd, EditTagsRemove} = this.props
        let removingTags = pendingRemovals.length > 0
        let addingTags = newTagNames.length > 0 || selectedTagIds.length > 0
        let payload
            payload = {
                wip_id: workInstructionId,
                newTagNames,
                selectedTagIds,
                }
        let removalPayload = {}
            removalPayload.wip_id = workInstructionId
            removalPayload.tagIdsForRemoval = pendingRemovals
        let nextTagsCollection = this.props.currentWorkInstructionTags
        if (removingTags && addingTags) {
           await Promise.all([EditTagsAdd(payload), EditTagsRemove(removalPayload)]).then((tagsBeingAdded, tagIdsRemoved) => {
            })
        } else if (addingTags && !removingTags) {
           await EditTagsAdd(payload).then(tags => {
            //tags.forEach(tag => {
                //nextTagsCollection.push(tag)
            //})
            })
        } else if (removingTags && !addingTags) {
            await EditTagsRemove(removalPayload).then(tags => {
                //nextTagsCollection.filter(tag => !tags.includes(tag._id))
            })
        }
        this.props.updateTags(nextTagsCollection)
    } 

    checkKey = (e) => {
        if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
            if(this.state.newTagName) {
                this.addTag(e, this.state.newTagName)
            }
        }
    }

    componentDidMount = () => {
            this.props.fetchAllTags()
            var newTagInput = document.getElementById("tag-name");
            newTagInput.addEventListener("keydown", this.checkKey);
    }

    componentWillUnmount = () => {
        var newTagInput = document.getElementById("tag-name");
        newTagInput.removeEventListener("keydown", this.checkKey)
    }

    addTag = (e, tagName) => {
        e.stopPropagation()
        let tag = undefined
        let tagExist = false
        Object.values(this.props.tags).forEach(tag => {
            if (tag.name === tagName) {
                tagExist = true
                tag = {name: tag.name, _id: tag._id}
            }
        })
        let allTags = this.state.allTags
        let selectedTagIds = this.state.selectedTagIds
        let newTagNames = this.state.newTagNames
        if (tagExist) {
            allTags.push(tag)
            selectedTagIds.push(tag._id)
            this.setState(prevState => ({
                allTags,
                selectedTagIds,
                newTagName: ""
            }));
        } else {
            newTagNames.push(tagName)
            this.setState(prevState => ({
                newTagNames,
                newTagName: ""
            }));
        }
    }

    selectTag = (e, tag) => {
        e.stopPropagation()
        let selectedTagIds = this.state.selectedTagIds
        let allTags = this.state.allTags
        selectedTagIds.push(tag._id)
        allTags.push(tag)
        
        this.setState(prevState => ({
            selectedTagIds,
            allTags
        }));
    }

    removePendingTagSelection = (e, pendingRemovalTagId) => {
        e.stopPropagation()
        let allTags = this.state.allTags
        let selectedTagIds = this.state.selectedTagIds
        let pendingRemovals = this.state.pendingRemovals
        //if pendingRemovalTagId is in the original tags passed in when component mounted push it into pendingRemovals
        if (this.props.currentWorkInstructionTags.some(tag => tag._id === pendingRemovalTagId)) {
            pendingRemovals.push(pendingRemovalTagId)
        } else {
            selectedTagIds = selectedTagIds.filter(tagId => tagId !== pendingRemovalTagId)
        }

        allTags =  allTags.filter(tag => tag._id !== pendingRemovalTagId)
        this.setState(prevState => ({
            selectedTagIds,
            allTags,
            pendingRemovals
        }));
    }

    removePendingTagName = (e, tagNameToBeRemoved) => {
        e.stopPropagation()
        this.setState({
            newTagNames: this.state.newTagNames.filter(tagName => tagName !== tagNameToBeRemoved)
        })
    }

    update(field) {
        return event => this.setState({
            [field]: event.currentTarget.value,
        });
    }

    render() {
        const currentTags = this.state.allTags.map(tag => {
            return <Tag isAttached={true}
                key={`edit-tag-form tagId ${tag._id}`}
                label={tag.name}
                handleDelete={(e) => this.removePendingTagSelection(e, tag._id)}
            />
        })
        
        const newTagNames = this.state.newTagNames.map(tagName => {
            return  <Tag isAttached={true} 
                label={tagName} 
                key={`edit-tags-form tagname-${tagName}`} 
                handleDelete={(e) => this.removePendingTagName(e, tagName)} 
            />})

        return <div>
            <ul id="selected-tag-names-container" className="flex wrap">
                <label>Current Tags:</label>
                {currentTags}
                {newTagNames}
            </ul>

            <div id="new-tag-name-container" className="flex wrap">
                <label>Add A New Tag</label>
                <input id="tag-name"
                    type="text"
                    value={this.state.newTagName}
                    onChange={this.update('newTagName')}
                    placeholder=""
                    />
            </div>

            <div className='input-box shadow' style={{ width: "97%" }}>
                <div id="search-tag-name-container">
                    <label>Search Recent/Popular Tags</label>
                    <input id="search-tag-name"
                        type="text"
                        value={this.state.searchInput}
                        onChange={this.update('searchInput')}
                        placeholder=""
                        />
                </div>
            </div>
           <TagSuggestions
                visible={true}
                tags={this.props.tags}
                query={this.state.searchInput}
                allTags={this.state.allTags}
                selectTag={this.selectTag} />
            <div className="flex-centered">
                <div className="button clickable" onClick={this.assignTags}>
                    <p >Confirm Tag Selection </p>
                </div>
            </div>
        </div>
  }
}
export default EditTagsForm